import React, { useState } from "react";
import S from "./style";
import TranslateStatic from '../../locales/TranslateStatic'
import { Link } from "react-router-dom";
import { LocaleContext } from '../../locale-context';

const trVideos = [
  { id: "Hmjea_LScoQ", title: "Konvansiyonel IVF Nasıl Yapılır?" },
  { id: "jBKyuEkzRcc", title: "Overyan Hiperstimülasyon Sendromu (OHSS) Nedir?" },
  { id: "Q-IA2Go6u_Y", title: "IVF tedavisinde kullanılan ilaçlar güvenli midir?" },
  { id: "WjxYjQTcoLM", title: "Tüp bebek tedavisi öncesinde istenen testler" }
];

const enVideos = [
  { id: "AiEZham2k8k", title: "Conventional IVF Procedure: A Step By Step Guide" },
  { id: "thzulzLEY6Q", title: "What is Ovarian Hyperstimulation Syndrome (OHSS)?" },
  { id: "Wzb107U8Ps8", title: "Are Drugs Used in IVF Safe?" },
  { id: "JWhcJfeCb5M", title: "Tests For Both Female and Male Patients Before IVF" }
];

export default function YouTubeList() {
  const [activeVideo, setActiveVideo] = useState(null);

  const openModal = (video) => setActiveVideo(video);
  const closeModal = () => setActiveVideo(null);

  return (
    <S.Wrapper>
      <S.Header>
        <div className="title-wrapper">
          <h1>
            <TranslateStatic string="Videolar" />
          </h1>
        </div>
        <Link to="youtube" className="more-button">
          <span><TranslateStatic string="referancesMoreButton" /></span>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
            <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"/>
          </svg>
        </Link>
      </S.Header>
      
      <S.Body>
        <LocaleContext.Consumer>
          {(value) => {
            const videos = value === "tr" ? trVideos : enVideos;
            return (
              <div className="bento-grid">
                {videos.map((video, index) => (
                  <div className={`video-card ${index === 0 ? 'hero-card' : 'sub-card'}`} key={index} onClick={() => openModal(video)}>
                    <div className="iframe-wrapper">
                      <img src={`https://img.youtube.com/vi/${video.id}/maxresdefault.jpg`} alt={video.title} />
                      <div className="gradient-overlay"></div>
                      <div className="play-button-overlay">
                        <svg viewBox="0 0 24 24" fill="currentColor">
                          <path d="M8 5v14l11-7z"/>
                        </svg>
                      </div>
                      <div className="video-title">
                        <h3>{video.title}</h3>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            );
          }}
        </LocaleContext.Consumer>
      </S.Body>

      {activeVideo && (
        <S.ModalOverlay onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={closeModal}>
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
              </svg>
            </button>
            <div className="modal-video-wrapper">
              <iframe 
                src={`https://www.youtube.com/embed/${activeVideo.id}?autoplay=1`}
                title={activeVideo.title} 
                frameBorder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                allowFullScreen>
              </iframe>
            </div>
          </div>
        </S.ModalOverlay>
      )}
    </S.Wrapper>
  );
}



